// Returns the blog lang ('en'|'es'|'pt') if pathname is a blog route, null otherwise.
export function getBlogLang(pathname) {
    if (!/^\/blog/.test(pathname)) return null;
    const m = /^\/blog\/(es|pt)(\/|$)/.exec(pathname);
    return m ? m[1] : 'en';
}

export function blogBase(lang) {
    return lang === 'en' ? '/blog' : `/blog/${lang}`;
}

export function blogPostsBase(lang) {
    return `${blogBase(lang)}/posts`;
}
